import React, {FC} from 'react';

import {useAppSelector} from 'store/config/hooks';
import {selectModalData, TModalComponentInterface} from 'store/slices/modals-slice';

import {FilterModal} from './filter-modal';

export const FilterModalContainer: FC<TModalComponentInterface> = ({
    onClose,
}: TModalComponentInterface) => {
    const entityName = useAppSelector(state => selectModalData(state)?.entityName) || '';
    return (
        <FilterModal
            entityName={entityName}
            onClose={onClose}
        />
    );
};
